// TODO - Set readonly on all inputs within the section
// Buttons are hidden via css should proabbly make them disabled as well JIC

function toggleLockButton(event) {
    const button = event.target;
    if (button.classList.contains("btn--lock")) {
        button.classList.toggle("is-locked");

        const span = button.querySelector("span");
        if (span) {
            span.textContent = span.textContent === "Lock" ? "Unlock" : "Lock";
        }

        const closestSection = button.closest("section");
        if (closestSection) {
            closestSection.classList.toggle("sectionIsLocked");

            const formElements = closestSection.querySelectorAll(
                "input, select, textarea",
            );
            formElements.forEach((element) => {
                element.readOnly = !element.readOnly;
            });
        }
    }
}

export function setupLockButtons() {
    const lockButtons = document.querySelectorAll(".btn--lock");
    lockButtons.forEach(function (button) {
        button.addEventListener("click", toggleLockButton);
    });
}
